export const QuestionData = [
  {
    id: 1,
    question: "평소에는 아무렇지도 않던 일들이 괴롭고 귀찮게 느껴졌다.",
    selected: false,
    answers: [
      { id: 1, score: 0, content: "1일 이하" },
      { id: 1, score: 2, content: "3~4일" },
      { id: 1, score: 1, content: "1~2일" },
      { id: 1, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 2,
    question: "먹고 싶지 않았다. 식욕이 없었다.",
    selected: false,
    answers: [
      { id: 2, score: 0, content: "1일 이하" },
      { id: 2, score: 1, content: "1~2일" },
      { id: 2, score: 2, content: "3~4일" },
      { id: 2, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 3,
    question: "어느 누가 도와주더라도 나의 울적한 기분을 떨쳐버릴 수 없을 것 같았다.",
    selected: false,
    answers: [
      { id: 3, score: 0, content: "1일 이하" },
      { id: 3, score: 1, content: "1~2일" },
      { id: 3, score: 2, content: "3~4일" },
      { id: 3, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 4,
    question: "무슨 일을 하든 정신을 집중하기가 힘들었다.",
    selected: false,
    answers: [
      { id: 4, score: 0, content: "1일 이하" },
      { id: 4, score: 1, content: "1~2일" },
      { id: 4, score: 2, content: "3~4일" },
      { id: 4, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 5,
    question: "비교적 잘 지냈다.",
    selected: false,
    answers: [
      { id: 5, score: 3, content: "1일 이하" },
      { id: 5, score: 2, content: "1~2일" },
      { id: 5, score: 1, content: "3~4일" },
      { id: 5, score: 0, content: "5~7일" },
    ],
  },
  {
    id: 6,
    question: "상당히 우울했다.",
    selected: false,
    answers: [
      { id: 6, score: 0, content: "1일 이하" },
      { id: 6, score: 1, content: "1~2일" },
      { id: 6, score: 2, content: "3~4일" },
      { id: 6, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 7,
    question: "모든 일들이 힘들게 느껴졌다.",
    selected: false,
    answers: [
      { id: 7, score: 0, content: "1일 이하" },
      { id: 7, score: 1, content: "1~2일" },
      { id: 7, score: 2, content: "3~4일" },
      { id: 7, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 8,
    question: "앞일이 암담하게 느껴졌다.",
    selected: false,
    answers: [
      { id: 8, score: 0, content: "1일 이하" },
      { id: 8, score: 1, content: "1~2일" },
      { id: 8, score: 2, content: "3~4일" },
      { id: 8, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 9,
    question: "지금까지의 내 인생은 실패작이라는 생각이 들었다.",
    selected: false,
    answers: [
      { id: 9, score: 0, content: "1일 이하" },
      { id: 9, score: 1, content: "1~2일" },
      { id: 9, score: 2, content: "3~4일" },
      { id: 9, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 10,
    question: "적어도 보통 사람들 만큼의 능력은 있었다고 생각한다.",
    selected: false,
    answers: [
      { id: 10, score: 3, content: "1일 이하" },
      { id: 10, score: 2, content: "1~2일" },
      { id: 10, score: 1, content: "3~4일" },
      { id: 10, score: 0, content: "5~7일" },
    ],
  },
  {
    id: 11,
    question: "잠을 설쳤다",
    selected: false,
    answers: [
      { id: 11, score: 0, content: "1일 이하" },
      { id: 11, score: 1, content: "1~2일" },
      { id: 11, score: 2, content: "3~4일" },
      { id: 11, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 12,
    question: "두려움을 느꼈다.",
    selected: false,
    answers: [
      { id: 12, score: 0, content: "1일 이하" },
      { id: 12, score: 1, content: "1~2일" },
      { id: 12, score: 2, content: "3~4일" },
      { id: 12, score: 3, content: "5~7일" },
    ],
  },
  {
    question: "평소에 비해 말수가 적었다.",
    selected: false,
    answers: [
      { id: 13, score: 0, content: "1일 이하" },
      { id: 13, score: 1, content: "1~2일" },
      { id: 13, score: 2, content: "3~4일" },
      { id: 13, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 13,
    question: "세상에 홀로 있는 듯한 외로움을 느꼈다.",
    selected: false,
    answers: [
      { id: 14, score: 0, content: "1일 이하" },
      { id: 14, score: 1, content: "1~2일" },
      { id: 14, score: 2, content: "3~4일" },
      { id: 14, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 14,
    question: "큰 불만 없이 생활했다.",
    selected: false,
    answers: [
      { id: 15, score: 3, content: "1일 이하" },
      { id: 15, score: 2, content: "1~2일" },
      { id: 15, score: 1, content: "3~4일" },
      { id: 15, score: 0, content: "5~7일" },
    ],
  },
  {
    id: 15,
    question: "사람들이 나에게 차갑게 대하는 것 같았다.",
    selected: false,
    answers: [
      { id: 16, score: 0, content: "1일 이하" },
      { id: 16, score: 1, content: "1~2일" },
      { id: 16, score: 2, content: "3~4일" },
      { id: 16, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 17,
    question: "갑자기 울음이 나왔다.",
    selected: false,
    answers: [
      { id: 17, score: 0, content: "1일 이하" },
      { id: 17, score: 1, content: "1~2일" },
      { id: 17, score: 2, content: "3~4일" },
      { id: 17, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 18,
    question: "마음이 슬펐다.",
    selected: false,
    answers: [
      { id: 18, score: 0, content: "1일 이하" },
      { id: 18, score: 1, content: "1~2일" },
      { id: 18, score: 2, content: "3~4일" },
      { id: 18, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 19,
    question: "사람들이 나를 싫어하는 것 같았다.",
    selected: false,
    answers: [
      { id: 19, score: 0, content: "1일 이하" },
      { id: 19, score: 1, content: "1~2일" },
      { id: 19, score: 2, content: "3~4일" },
      { id: 19, score: 3, content: "5~7일" },
    ],
  },
  {
    id: 20,
    question: "도무지 뭘 해 나갈 엄두가 나지 않았다.",
    selected: false,
    answers: [
      { id: 20, score: 0, content: "1일 이하" },
      { id: 20, score: 1, content: "1~2일" },
      { id: 20, score: 2, content: "3~4일" },
      { id: 20, score: 3, content: "5~7일" },
    ],
  },
];
